<script>
export default {
  props: {
    name: String,
    attr: Object,
    option: String,
    checked: String,
    value: Boolean,
    validate: {default:""},
    disabled: Boolean,
  },
  data(){
    return {
      input: this.value,
    }
  },
  methods:{
    onClick(){
      this.$emit('input', !this.value)
      setTimeout(()=>$(this.$el).find("input").valid(), 10)
    }
  },
  watch:{
    input(v){ this.$emit("input", v); },
    value(v){ this.input = v; },
  }
}
</script>

<template>
  <div class="inline checkbox checkbox-info" @click="onClick">
    <input type="checkbox" v-model="input" :name="name" :value="option" v-bind="attr">
    <label><slot></slot></label>
  </div>
</template>